export default "__VITE_ASSET__BxVD2Qai__"